// REACT & Libraries
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

// Table
import IndustryTable from "../../DataTables/MasterData/Industry/IndustryTable";

// Modals
import CreateIndustryModal from "../../UiKits/Modal/MasterData/Industry/CreateIndustry";

const IndustryContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Industries" parent="Master Data" />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <H5 className="mb-0">Industries Master Data</H5>
                <P className="mb-3 f-light f-w-200 f-12">
                  Manage industries options used throughout the HRIS for
                  employee and applicant personal information.
                </P>
                <CreateIndustryModal />
                <IndustryTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default IndustryContainer;
